export default {"src":"/_next/static/media/facebook.53764c69.svg","height":23,"width":14,"blurWidth":0,"blurHeight":0};